import React, { Component } from 'react';
import { Example, Properties, SourceCode } from 'examples';
import Stopwatch from './Stopwatch';

class StopwatchExample extends Component {

  state = {
    value: 168000,
  };

  onChange = value => this.setState({ value });

  onPropChange = e => this.setState(e.target.value);

  render() {
    const properties = { ...Stopwatch.propTypes };
    const defaultProperties = { ...Stopwatch.defaultProps };

    return (
      <Example {...this.props}>
        <Properties defaultProps={defaultProperties} onChange={this.onPropChange} propTypes={properties} propValues={this.state}/>
        <Stopwatch {...this.state} onChange={this.onChange}/>
        <SourceCode querySelector=".core-stopwatch"/>
      </Example>
    );
  }

}

StopwatchExample.tags = 'input time';

export default StopwatchExample;
